import type { ComponentType, SVGProps } from "react";
import {
  ArrowTrendingUpIcon,
  BeakerIcon,
  BookOpenIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ComputerDesktopIcon,
  EnvelopeOpenIcon,
  FireIcon,
  FolderIcon,
  LightBulbIcon,
  PhoneIcon,
  ScaleIcon,
  ShieldExclamationIcon,
  SwatchIcon,
  TruckIcon,
} from "@heroicons/react/24/outline";

type Icon = ComponentType<SVGProps<SVGSVGElement>>;

const RULES: Array<[RegExp, Icon]> = [
  [/kleidung|arbeitskleid/i, SwatchIcon],
  [/unfall|erste hilfe|ersthelfer/i, ShieldExclamationIcon],
  [/aufma(ß|ss)/i, ArrowTrendingUpIcon],
  [/gesetz|aushang/i, ScaleIcon],
  [/brandschutz|feuer/i, FireIcon],
  [/betriebs|campus|ordnung|hausordnung/i, BuildingOffice2Icon],
  [/edv|it[- ]|anleitung|computer|software/i, ComputerDesktopIcon],
  [/fahrt|fahrzeug|kfz/i, TruckIcon],
  [/gefahr|chemie|stoff/i, BeakerIcon],
  [/information|schreiben|mitteilung|newsletter/i, EnvelopeOpenIcon],
  [/telefon|kontakt/i, PhoneIcon],
  [/urlaub|antrag|abwesen/i, CalendarDaysIcon],
  [/bibel|wenn[- ]dann|faq|wissen/i, LightBulbIcon],
  [/handbuch|buch/i, BookOpenIcon],
];

/** Passendes Symbol zum Ordnernamen (Fallback: Ordner). */
export function folderIconFor(name: string): Icon {
  for (const [pattern, icon] of RULES) {
    if (pattern.test(name)) return icon;
  }
  return FolderIcon;
}
